import { render, staticRenderFns } from "./Fare.vue?vue&type=template&id=00eee5c0&scoped=true&"
import script from "./Fare.vue?vue&type=script&lang=js&"
export * from "./Fare.vue?vue&type=script&lang=js&"
import style0 from "./Fare.vue?vue&type=style&index=0&id=00eee5c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eee5c0",
  null
  
)

export default component.exports